import { Store, toImmutable, Immutable } from 'nuclear-js';
import Actions from '../actions';

export default Store({
    getInitialState() {
        return toImmutable({
            userBid: null,
            username: null,
            firstName: null,
            lastName: null,
            roles: null,
            isLoggedIn: false,
            links: Immutable.List(),
            reportsHomeLink: null,
            reportsQueueLink: null,
            partnerBid: null,
            chartPreferences: Immutable.Map(),
            profileCheckCompleted: false,
        });
    },

    initialize() {
        this.on(Actions.user.STORE_USER_DATA, storeUserData);
        this.on(Actions.user.STORE_USER_LINKS, storeUserLinks);
        this.on(Actions.runtime.CLEAR_STATE, (state) => this.getInitialState());
        this.on(Actions.user.SET_CHART_PREFERENCE, saveChartPreference);
        this.on(Actions.user.SET_PROFILE_CHANGE_CHECK_COMPLETED, setProfileCheckCompleted);
    },
});

function setProfileCheckCompleted(state, completed) {
    return state.set('profileCheckCompleted', completed);
}

function storeUserLinks(state, menus) {
    const userLinks = toImmutable(menus.primaryMenuItems);

    try {
        const reportsList = userLinks.find((userLink) => userLink.get('displayText') === 'View Reports');
        const reports = reportsList.get('subMenu');
        var reportsHomeInfo = reports.find(
            (report) => report.get('displayText').toLowerCase() === 'map growth reports'
        );
        var reportsQueueInfo = reports.find((report) => report.get('displayText').toLowerCase() === 'reports queue');
    } catch (error) {
        console.error(error);
    }

    return state.withMutations((state) => {
        state
            .set('links', userLinks)
            .set('reportsHomeLink', reportsHomeInfo ? reportsHomeInfo.get('link') : '')
            .set('reportsQueueLink', reportsQueueInfo ? reportsQueueInfo.get('link') : '');
    });
}

function storeUserData(state, profileInfo) {
    if (!profileInfo || !profileInfo.userProfile) {
        throw `unexpected data from profile endpoint: ${profileInfo}`;
    }
    const userProfile = profileInfo.userProfile;
    return state.withMutations((state) => {
        state
            .set('username', userProfile['username'])
            .set('firstName', userProfile['firstName'])
            .set('lastName', userProfile['lastName'])
            .set('partnerBid', userProfile['partnerBid'])
            .set('userBid', userProfile['userBid'])
            .set('roles', toImmutable(userProfile.roles))
            .set('partnerId', userProfile.partnerId)
            .set('isLoggedIn', true)
            .set('profileCheckCompleted', true);
    });
}

function saveChartPreference(state, chartPreferencePayload) {
    const chartIndex = chartPreferencePayload.chartSeriesIndex;
    return state.setIn(['chartPreferences', chartIndex], chartPreferencePayload.chartSeriesIndexPreference);
}
